import { OfficeInternalContactList } from '../../../../components/Contact';

export function TBMContactOfficeInternalContacts() {
  return <OfficeInternalContactList />;
}
